import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'zaver-pill',
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.scss'],
})
export class PillComponent implements OnInit {
  @Input() text: string;
  @Input() isSelected: boolean;

  constructor() {}

  ngOnInit(): void {}
}
